import { asStringArray, mapDtoList, optionalEnum, optionalString, requireObject, requireString } from './parse.js';

/** Mirrors com.medprompt.shared.identity.EhrSystemType */
export const EhrSystemType = Object.freeze({
  EMIS: 'EMIS',
  SYSTM_ONE: 'SYSTM_ONE',
});

/**
 * Mirrors com.medprompt.identity.clinic.ClinicData
 *
 * @typedef {object} ClinicData
 * @property {string} clinicId
 * @property {string} clinicName
 * @property {string[]} products Jackson Set<Product> — DOCUMENTS, SCRIBE
 * @property {string} ehrSystem EhrSystemType — EMIS when absent
 * @property {string|null} odsCode
 */

/**
 * @param {object} raw
 * @returns {ClinicData}
 */
export function fromClinicData(raw) {
  const source = requireObject(raw, 'ClinicData');
  return {
    clinicId: requireString(source, 'clinicId', 'ClinicData'),
    clinicName: requireString(source, 'clinicName', 'ClinicData'),
    products: asStringArray(source.products),
    ehrSystem: optionalEnum(source.ehrSystem, EhrSystemType, 'ClinicData', 'ehrSystem') ?? EhrSystemType.EMIS,
    odsCode: optionalString(source.odsCode),
  };
}

/**
 * @param {unknown} raw
 * @returns {ClinicData[]}
 */
export function fromClinicDataList(raw) {
  return mapDtoList(raw, 'ClinicData', fromClinicData);
}

/**
 * Admin directory enrichment — not on the Java DTO.
 *
 * @param {ClinicData} clinic
 * @param {number} userCount
 * @param {number} teamCount
 * @returns {ClinicData & { userCount: number, teamCount: number }}
 */
export function withClinicCounts(clinic, userCount, teamCount) {
  return {
    ...clinic,
    userCount,
    teamCount,
  };
}
